import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, resolveComponent as _resolveComponent, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["aria-expanded"];
import { ref, reactive, watch, inject } from 'vue';
import { useFocusWithin } from '@vueuse/core';
import { throttle } from '../../helpers';
import NavBarHeaderTag from './NavBarHeaderTag.vue';
export default {
  __name: 'NavBarSimpleDropdown',
  setup(__props) {
    const focusTrap = inject("focusTrap", {
      focusNextElement: () => {},
      focusPrevElement: () => {}
    });
    const dropdown = ref(null);
    const dropdownHeader = ref(null);
    const dropdownContent = ref(null);
    const {
      focused
    } = useFocusWithin(dropdown);
    const state = reactive({
      visible: false
    });
    // Methods

    const handleOpen = () => {
      state.visible = true;
    };
    const handleClose = () => {
      state.visible = false;
    };
    const getDropdownItems = () => {
      return dropdownContent.value?.getFocusableElements() ?? [];
    };
    const handleMenuClose = () => {
      handleClose();
      dropdownHeader.value?.$el.focus();
    };
    const handleDropdownKeydownLeft = event => {
      if (!state.visible) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      handleMenuClose();
      focusTrap.focusPrevElement();
    };
    const handleDropdownKeydownRight = event => {
      if (!state.visible) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      handleMenuClose();
      focusTrap.focusNextElement();
    };
    const handleSubmenuOpen = throttle((start = "first") => {
      // Defer update to the next tick
      setTimeout(() => {
        const dropdownItems = getDropdownItems();
        if (dropdownItems.length > 0) {
          if (start === "first") {
            dropdownItems[0]?.focus();
          } else if (start === "last") {
            dropdownItems[dropdownItems.length - 1]?.focus();
          }
        }
      }, 0);
    }, 200); // Throttle to avoid multiple calls in quick succession while the dropdown is opening

    const handleHeaderKeydown = event => {
      switch (event.key) {
        case ' ':
        case 'Enter':
        case 'ArrowDown':
          event.preventDefault();
          handleOpen();
          handleSubmenuOpen("first");
          break;
        case 'ArrowUp':
          event.preventDefault();
          handleOpen();
          handleSubmenuOpen("last");
          break;
      }
    };
    watch(focused, (newVal, oldVal) => {
      if (!newVal && oldVal) {
        handleClose();
      }
    });
    return (_ctx, _cache) => {
      const _component_FocusTrap = _resolveComponent("FocusTrap");
      return _openBlock(), _createElementBlock("div", {
        class: "dropdown-container",
        ref_key: "dropdown",
        ref: dropdown,
        "aria-expanded": state.visible,
        onMouseleave: _cache[1] || (_cache[1] = () => handleClose()),
        onKeydown: [_withKeys(handleDropdownKeydownLeft, ["left"]), _withKeys(handleDropdownKeydownRight, ["right"])]
      }, [_createVNode(NavBarHeaderTag, {
        active: state.visible,
        role: "button",
        tabindex: "0",
        onMouseenter: _cache[0] || (_cache[0] = () => handleOpen()),
        onKeydown: handleHeaderKeydown,
        ref_key: "dropdownHeader",
        ref: dropdownHeader
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["active"]), _createVNode(_component_FocusTrap, {
        ref_key: "dropdownContent",
        ref: dropdownContent,
        escCallback: handleMenuClose
      }, {
        default: _withCtx(() => [_createVNode(_Transition, {
          name: "fast-fade"
        }, {
          default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
            class: "dropdown",
            onClick: handleMenuClose
          }, [_renderSlot(_ctx.$slots, "dropdown-content")], 512), [[_vShow, state.visible]])]),
          _: 3
        })]),
        _: 3
      }, 512)], 40, _hoisted_1);
    };
  }
};